import {useContext} from "react";
import CraigContext from "./craigContext";

const useCraig = () => useContext(CraigContext);

export default useCraig;
